import React from 'react';

export const starPath =
  'M62.52 21.984l-22.076-1.43L32.263 0 24.08 20.554 2 21.984l17.025 14.132-5.463 21.438 18.7-11.82 18.701 11.82L45.5 36.116z';
export default class Star extends React.PureComponent {
  render() {
    return <path d={starPath} className="fill-current" />;
  }
}
